import { NgModule } from '@angular/core';
import { DatePipe, DecimalPipe, SlicePipe, TitleCasePipe, UpperCasePipe, LowerCasePipe, CurrencyPipe, PercentPipe, AsyncPipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { ScrollTrackerDirective } from './scroll-tracker.directive';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SimplebarAngularModule } from 'simplebar-angular';
import { BaseChartDirective } from 'ng2-charts';


// Directive
import { ScrollspyDirective } from './scrollspy.directive';

// components
import { FilterControlComponent } from './filter-control/filter-control.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ChartInfoComponent } from './charts/info-cart/chart-info.component';
import { SummaryCardComponent } from './charts/summary-card/summary-card.component';
import { StackedBarComponent } from './charts/chart-card/stackedBar/stackedBar-chart.component';
import { StackedBarLineComponent } from './charts/chart-card/stackedBar-line/stackedBar-line-chart.component';
import { DashboardChartComponent } from './charts/chart-card/dashboardChart/dashboardChart.component';

import { UserActivityLogs } from './user-activity-logs/user-activity-logs.component';
import { LanguageSelectComponent } from './language-select/language-select.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NoDataFoundComponent } from './no-data-found/no-data-found.component';
import { LeanAccessPeriodComponent } from './lean-access-period/lean-access-period.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { AIChatPoupUpComponent } from '../pages/deben-AI-assistant/ai-chat-poup-up/ai-chat-poup-up.component';
import { GenericPivotTableComponent } from './pivot-table/generic-pivot-table.component';
import { InactivityTimerComponent } from './inactivity-timer/inactivity-timer.component';
import { CalendarHeatmapComponent } from './calendar-heatmap/calendar-heatmap.component';
import { DirectivesModule } from './directives.module';
import { AuthFooterComponent } from './auth-footer/auth-footer.component';
import { SkeletonLoaderComponent } from './loading-states/skeleton-loader/skeleton-loader.component';
import { LoadingOverlayComponent } from './loading-states/loading-overlay/loading-overlay.component';

const maskConfig = {
  validation: false,
};

@NgModule({
  declarations: [
    UserActivityLogs,
    ScrollTrackerDirective,
    ScrollspyDirective,
    StackedBarComponent,
    StackedBarLineComponent,
    DashboardChartComponent,
    AIChatPoupUpComponent
  ],
  imports: [
    // Standalone components
    BreadcrumbsComponent,
    NoDataFoundComponent,
    ChartInfoComponent,
    SummaryCardComponent,
    FilterControlComponent,
    GenericPivotTableComponent,
    CalendarHeatmapComponent,
    LeanAccessPeriodComponent,
    InactivityTimerComponent,
    LanguageSelectComponent,
    AuthFooterComponent,
    SkeletonLoaderComponent,
    LoadingOverlayComponent,
    // Modules
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule,
    NgxSliderModule,
    NgSelectModule,
    FlatpickrModule,
    SimplebarAngularModule,
    BaseChartDirective,
    NgApexchartsModule,
    RouterModule,
    QRCodeComponent,
    DirectivesModule,
    NgxMaskDirective,
    NgxMaskPipe,
    DatePipe,
    DecimalPipe,
    SlicePipe,
    TitleCasePipe,
    UpperCasePipe,
    LowerCasePipe,
    CurrencyPipe,
    PercentPipe,
    AsyncPipe,
  ],
  exports: [
    // Components
    BreadcrumbsComponent,
    FilterControlComponent,
    UserActivityLogs,
    ScrollTrackerDirective,
    ScrollspyDirective,
    ChartInfoComponent,
    SummaryCardComponent,
    StackedBarComponent,
    StackedBarLineComponent,
    DashboardChartComponent,
    LanguageSelectComponent,
    NoDataFoundComponent,
    LeanAccessPeriodComponent,
    AIChatPoupUpComponent,
    GenericPivotTableComponent,
    InactivityTimerComponent,
    CalendarHeatmapComponent,
    AuthFooterComponent,
    SkeletonLoaderComponent,
    LoadingOverlayComponent,

    // Re-export modules so they're available in consuming modules
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule,
    NgxSliderModule,
    NgSelectModule,
    FlatpickrModule,
    SimplebarAngularModule,
    BaseChartDirective,
    NgApexchartsModule,
    DirectivesModule,
    RouterModule,
    QRCodeComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    DatePipe,
    DecimalPipe,
    SlicePipe,
    TitleCasePipe,
    UpperCasePipe,
    LowerCasePipe,
    CurrencyPipe,
    PercentPipe,
    AsyncPipe,

  ],
  providers: [DatePipe, DecimalPipe, provideNgxMask(maskConfig)]
})
export class SharedModule { }
